import { VenueDetailsBySlugResponse } from "common/hooks";
import { GoogleMap, Marker } from "@react-google-maps/api";
import OrangePin from "@/assets/pins/orange_pin.svg";
import { useLoadGoogleMaps } from "@/hooks/useLoadGoogleMaps";
import { useDarkMode } from "@/hooks/useDarkMode";
import { googleMapDarkModeId, googleMapId } from "common/config";

type VenueInfoGoogleMapProps = {
  venueDetailsReponse: VenueDetailsBySlugResponse;
  fullSize?: boolean;
};

function VenueInfoGoogleMap({
  venueDetailsReponse,
  fullSize,
}: VenueInfoGoogleMapProps) {
  const venueDetails = venueDetailsReponse.details;
  const { isMapsLoaded } = useLoadGoogleMaps();
  const isDark = useDarkMode();

  return (
    <>
      {fullSize && isMapsLoaded && (
        <div
          className="md:col-span-5 max-h-[300px]"
          aria-hidden="true"
          tabIndex={-1}
        >
          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "100%",
            }}
            options={{
              keyboardShortcuts: false,
              fullscreenControl: false,
              disableDefaultUI: true,
              mapId: isDark ? googleMapDarkModeId : googleMapId,
            }}
            center={{
              lat: venueDetails.latitude,
              lng: venueDetails.longitude,
            }}
            zoom={16}
          >
            <Marker
              position={{
                lat: venueDetails.latitude,
                lng: venueDetails.longitude,
              }}
              title={venueDetails.name}
              icon={{
                url: OrangePin,
                anchor: new google.maps.Point(15, 30),
                size: new google.maps.Size(30, 30),
                scaledSize: new google.maps.Size(30, 30),
              }}
            ></Marker>
          </GoogleMap>
        </div>
      )}
    </>
  );
}

export default VenueInfoGoogleMap;
